import { Notification } from '@features/enterpriseNotifications/types';
import dayjs from 'dayjs';


export const formNotificationTitle = (notification: Notification) => {
  switch (notification.notification_type) {
    case 'APPLICANT COMPLETED ONBOARDING':
      return 'Onboadring Documents Complete';
    case 'NEW MESSAGE':
      return 'New Message';
    default:
      return notification.message;
  }
};

export const formNotificationSecondaryText = (notification: Notification) => {
  const { associated_user, application, date_created } = notification;

  return [
    associated_user?.name,
    application?.position,
    dayjs(date_created).format('MM/DD/YYYY - h:mm A'),
  ]
    .filter(Boolean)
    .join(' - ');
};
